import { ContactView } from "~landing/views/contact";
import { NextPage } from "next";
import { MarketingSeo } from "~landing/seo/marketing-seo";
import { useEffect } from "react";
import { sendPublicPageViewEvent } from "~tag-manager/send-event";

const ContactPage: NextPage = () => {
	useEffect(() => {
		sendPublicPageViewEvent({ page_category: "utility" });
	}, []);

	return (
		<>
			<MarketingSeo
				path="/contact"
				title="Contact"
			/>
			<ContactView />
		</>
	);
};

export default ContactPage;
